import { render, staticRenderFns } from "./BaseHeader.vue?vue&type=template&id=5e13e402&scoped=true&"
import script from "./BaseHeader.vue?vue&type=script&lang=ts&"
export * from "./BaseHeader.vue?vue&type=script&lang=ts&"
import style0 from "./BaseHeader.vue?vue&type=style&index=0&id=5e13e402&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e13e402",
  null
  
)

export default component.exports